import { TelemetryEvents } from '@monorepo/shared/src/types';
import BaseTelemetryProvider from '@monorepo/shared/src/providers/BaseTelemetryProvider';
import CREATE_ACCESS_ACTIVITY_PAGE_EVENT from '@monorepo/shared/src/graph/mutations/create-access-activity-page-event';
import CREATE_ACCESS_LINK_EVENT from '@monorepo/shared/src/graph/mutations/create-access-link-event';
import CREATE_ACCESS_PAGE_EVENT from '@monorepo/shared/src/graph/mutations/create-access-page-event';
import CREATE_ACCESS_RESOURCE_EVENT from '@monorepo/shared/src/graph/mutations/create-access-resource-event';
import CREATE_LOGIN_SUCCESS_EVENT from '@monorepo/shared/src/graph/mutations/create-login-success-event';
import CREATE_READ_BOOK_EVENT from '@monorepo/shared/src/graph/mutations/create-read-book-event';
import CREATE_TEACHING_ORDER_CHANGED_EVENT from '@monorepo/shared/src/graph/mutations/create-teaching-order-changed-event';
import CREATE_VIEW_TAB_EVENT from '@monorepo/shared/src/graph/mutations/create-view-tab-event';

const mutationMap = {
  [TelemetryEvents.ACCESS_ACTIVITY_PAGE]: CREATE_ACCESS_ACTIVITY_PAGE_EVENT,
  [TelemetryEvents.ACCESS_LINK]: CREATE_ACCESS_LINK_EVENT,
  [TelemetryEvents.ACCESS_PAGE]: CREATE_ACCESS_PAGE_EVENT,
  [TelemetryEvents.ACCESS_RESOURCE]: CREATE_ACCESS_RESOURCE_EVENT,
  [TelemetryEvents.LOGIN_SUCCESS]: CREATE_LOGIN_SUCCESS_EVENT,
  [TelemetryEvents.READ_BOOK]: CREATE_READ_BOOK_EVENT,
  [TelemetryEvents.TEACHING_ORDER_CHANGED]: CREATE_TEACHING_ORDER_CHANGED_EVENT,
  [TelemetryEvents.VIEW_TAB]: CREATE_VIEW_TAB_EVENT,
};

const TelemetryProvider = (props) => {
  return (
    <BaseTelemetryProvider {...props} telemetryEventsMutationMap={mutationMap}>
      {props.children}
    </BaseTelemetryProvider>
  );
};

export default TelemetryProvider;
